import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { elprisReportQuery } from "@/lib/elprisReportQuery";

const ElprisReport = lazy(() => import("@/pages/ElprisReport"));

const TITLE = "Elpriset i Sverige – interaktiv rapport med 10+ års spotpriser » Elmarknad.se";
const DESC = "Interaktiv rapport: spotpriset i SE1–SE4 över mer än tio år, elkostnad per hustyp, säsongsmönster, prisskillnad norr–söder och alla 290 kommuner.";

export const Route = createFileRoute("/rapporter/elpriset-i-sverige")({
  loader: ({ context }) => context.queryClient.ensureQueryData(elprisReportQuery),
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://elmarknad.se/rapporter/elpriset-i-sverige" }],
    scripts: [{
      type: "application/ld+json",
      children: JSON.stringify({
        "@context": "https://schema.org", "@type": "Dataset", name: "Elpriset i Sverige", description: DESC,
        url: "https://elmarknad.se/rapporter/elpriset-i-sverige", creator: { "@type": "Organization", name: "Elmarknad.se" },
        spatialCoverage: "Sverige (SE1–SE4)", license: "https://creativecommons.org/licenses/by/4.0/",
      }),
    }],
  }),
  component: () => <ElprisReport />,
});
